import { Button, Stack, type Theme, Typography } from '@mui/material';
import Icon from '/@/components/icon';
import { _ } from '/@/locale';

const RegistryNextCrop = ({
    onRecommendHybrid,
    onAddCrop,
}: {
    onRecommendHybrid: () => void;
    onAddCrop: () => void;
}) => {
    return (
        <Stack
            alignItems='center'
            justifyContent='center'
            spacing={2}
            sx={{ backgroundColor: 'grey.100', border: 1, borderColor: 'primary.mui.stroke', borderRadius: 2, p: 2 }}
        >
            <Icon
                type='agronomy'
                sx={{
                    width: 36,
                    height: 36,
                    '& svg *': {
                        fill: (t: Theme) => `${t.palette.primary.main} !important`,
                        fillOpacity: '1 !important',
                    },
                }}
            />
            <Stack alignItems='center' spacing={1} sx={{ px: 3, textAlign: 'center' }}>
                <Typography variant='subtitle1' fontWeight='bold' color='primary'>
                    {_('Próximo cultivo')}
                </Typography>
                <Typography variant='body2' color='primary'>
                    {_('Agregá el cultivo para hacer un mejor seguimiento de la campaña.')}
                </Typography>
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ width: { xs: '100%', sm: 'auto' } }}>
                <Button
                    variant='outlined'
                    sx={{ background: 'white', width: { xs: '100%', sm: 'auto' } }}
                    color='primary'
                    onClick={onRecommendHybrid}
                >
                    {_('Recomendar hibrido')}
                </Button>
                <Button
                    variant='contained'
                    color='primary'
                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                    onClick={onAddCrop}
                >
                    {_('Agregar cultivo')}
                </Button>
            </Stack>
        </Stack>
    );
};

export default RegistryNextCrop;
